import helperRequest from './helperRequest';

// In a browser, Reader Connector is a separate desktop app reached through its
// backbone-reader-setup: link, and page requests travel sealed through Backbone.
// connector.native.js runs the same helper inside the Android app instead.
export default {
    keepOpenMessage: 'Keep Reader Connector open.',
    provisioningMessage: 'Provisioning readers. This may take a few minutes. Keep Reader Connector open; each row updates automatically.',
    connectingMessage:
        'Waiting for Reader Connector. If it opens, accept the connection prompt. If nothing opens, launch the installed app and try again.',
    origin: () => window.location.origin,
    open: (link, appearance) => {
        const url = new URL(link);
        const input = url.hash ? JSON.parse(decodeURIComponent(url.hash.slice(1))) : {};
        url.hash = encodeURIComponent(JSON.stringify({ ...input, appearance }));
        window.location.assign(url.href);
    },
    download: url => window.location.assign(url),
    request: helperRequest,
    forget: async () => {}
};
